import { ApiError, Box, Text } from "@shared/primitive-components"
import { SummaryCardMainText } from "../.."
import { InsightsPeriod } from "../../../../api/insights"
import { useListPeriodVehicles } from "../../../../api/insights/periods"
import { PATHS } from "../../../../const/paths"
import { usePolicyAndFleet } from "../../../../contexts"
import { worstSpeedersStyles as styles } from "../../../styles"
import { WorstSpeedersList } from "."

const TooltipContent = (
  <Text css={styles.tooltip}>
    Your fleet&apos;s 5 worst speeders over the last 30 days. To qualify, these drivers must have a minimum of 10 miles
    driven.
  </Text>
)

type Props = {
  activePeriod: InsightsPeriod | null
  loading?: boolean
}

export const WorstSpeeders = ({ activePeriod, loading }: Props) => {
  const { policy } = usePolicyAndFleet()
  const [res] = useListPeriodVehicles({
    limit: 5,
    minimumDistanceDriven: 16,
    periodNumber: activePeriod?.number || 0,
    policyId: policy.id as string,
    sortKey: `riskScore`,
    sortOrder: `DESC`,
  })

  if (res.result?.tag === `err`) return <ApiError />

  return (
    <Box css={styles.worstSpeedersContainer}>
      <SummaryCardMainText
        main="Worst speeders in the fleet"
        tooltip={TooltipContent}
        expand={{
          label: `View all`,
          path: PATHS.INSIGHTS.VEHICLES,
        }}
        hasData={res?.result?.data && res?.result?.data?.length > 0}
      />
      <WorstSpeedersList activePeriod={activePeriod} data={res?.result?.data || []} loading={loading || res?.loading} />
    </Box>
  )
}

WorstSpeeders.defaultProps = {
  loading: undefined,
}
